import axios from "axios";
import { appConfig } from "@/shared/config";
import { normalizeHttpError } from "./httpError";
import { API_TIMEOUT_MS, installRetry } from "./resilience";
import { installSimulatedLatency } from "./simulatedLatency";

/**
 * Overlord(인증 서버) client.
 *
 * Owns:
 * - Overlord 요청(GitHub 로그인 start/login, MCP 연결 코드 발급)의 baseURL · timeout · 에러 정규화.
 *
 * Does not own:
 * - 발급된 JWT 의 보관·첨부(`apiClient` 와 세션 상태가 소유). 이 client 는 Bearer 를 자동으로 붙이지
 *   않는다 — start/login 은 미인증 요청이다. Bearer 가 필요한 요청은 연결 코드 발급 하나이고 그
 *   호출부가 헤더를 명시한다. Overlord 의 401 은 이 앱의 세션 무효화로 다루지 않는다.
 */
export const authClient = axios.create({
  baseURL: appConfig.authBaseUrl,
  timeout: API_TIMEOUT_MS,
  headers: {
    "Content-Type": "application/json",
  },
});

installSimulatedLatency(authClient);
// 재시도는 idempotent(GET /start)에만 걸린다. POST /login 의 state 는 1회용이라 재시도하면 같은
// 실패(state.invalid)를 반복할 뿐이다.
installRetry(authClient);

authClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => Promise.reject(normalizeHttpError(error)),
);
